import type { ParentComponent } from "solid-js";
import { createMemo, createRenderEffect, Show } from "solid-js";
import { useAuthDispatch, useAuthState } from "../state/auth";
import { useLocation } from "@solidjs/router";
import { isNil } from "lodash-es";
import { UserProvider } from "../state/user";
import { LocalUserSettingsProvider } from "../state/localUserSettings";
import RootPage from "./RootPage";

const RouteGuard: ParentComponent = (props) => {
  const { loginStatus, user } = useAuthState();
  const { logout } = useAuthDispatch();
  const loggedIn = createMemo(() => loginStatus() === "loggedIn");
  const location = useLocation();

  createRenderEffect(() => {
    const providedUsername = location.query.username;
    const currentUsername = user()?.profile.sub;
    if (isNil(providedUsername) || isNil(currentUsername)) {
      return;
    }
    if (providedUsername !== currentUsername) {
      void logout(location.pathname);
    }
  });

  return (
    <Show when={loggedIn()} fallback={<RootPage />}>
      <UserProvider value={undefined}>
        <LocalUserSettingsProvider value={undefined}>{props.children}</LocalUserSettingsProvider>
      </UserProvider>
    </Show>
  );
};

export default RouteGuard;
